/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'

import UpIcon from '../../static/images/arrow-up.svg'
import DownIcon from '../../static/images/arrow-down.svg'

/** @param {{ up?: boolean }} props */
const arrowDirection = props => (props.up ? UpIcon : DownIcon)

const Arrow = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 12px;

  display: inline-block;
  cursor: pointer;

  background-image: url(${arrowDirection});
  background-repeat: no-repeat;
  background-size: 13px;
  background-position: 50% 45%;
`

/**
 * @typedef {object} Props
 * @property {string} direction
 */

/**
 * @typedef {Props} State
 */

/**
 * @extends {React.Component<React.HTMLAttributes<HTMLDivElement> & Props, State>}
 */
class ToggleableArrow extends React.Component {
  /**
   * @param {Props} props
   */
  static getDerivedStateFromProps = ({ direction }) => {
    if (direction) return { direction }
    return null
  }

  state = { direction: 'down' }

  /**
   * @param {React.MouseEvent<HTMLDivElement, MouseEvent>} e
   */
  toggle = e => {
    const { onClick } = this.props
    this.setState(state => ({
      direction: state.direction === 'up' ? 'down' : 'up',
    }))
    if (onClick) onClick(e)
  }

  render = () => {
    const { onClick, ...otherProps } = this.props
    return <Arrow up={ this.state.direction === 'up' } onClick={ this.toggle } { ...otherProps } />
  }
}

export default ToggleableArrow



// WEBPACK FOOTER //
// ./src/lib/components/Arrow.jsx